import gql from 'graphql-tag';

export const GET_LIST_OF_TRUCK_MANUFACTURERS = gql`
  query GetListOfManufacturers {
    truckManufacturers {
      value: dcrCode
      label: name
    }
  }
`;
